import React from 'react'
import styled from "styled-components";

import logo_lmt from '../assets/images/lmt-logo.png';

const Brand = () => {
  return (
    <Image src={logo_lmt} className="logo-lmt" alt="Light Miles Travel" />
  )
}

export default Brand

const Image = styled.img`
  height: 85%;
  margin: auto 0;
`;